import type { ReactNode } from "react";
import { Typography } from "@mui/material";

interface DryBulkSectionProps {
  testId: string;
  title: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
}

/** Plain, non-collapsible section: a heading row (title left, optional action right) and the content (DBVN-0021, R-A). */
const DryBulkSection: React.FC<DryBulkSectionProps> = ({ testId, title, action, children }) => (
  <section data-testid={testId} className="flex flex-col gap-3">
    <div className="flex items-center justify-between">
      <Typography variant="body2" component="h3">
        {title}
      </Typography>
      {action}
    </div>
    {children}
  </section>
);

export default DryBulkSection;
